(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('ErrorInterceptor', ErrorInterceptor);

    ErrorInterceptor.$inject = ['$injector', '$q', 'localStorageService'];

    /* @ngInject */
    function ErrorInterceptor($injector, $q, localStorageService) {
        var toastr, mdDialog, UserService;
        function getToaster() {
            if (!toastr) {
                toastr = $injector.get('$mdToast');
            }
            return toastr;
        }

        function getDialog() {
            if (!mdDialog) {
                mdDialog = $injector.get('$mdDialog');
            }
            return mdDialog;
        }
        function getUserService() {
            if (!UserService) {
                UserService = $injector.get('UserService');
            }
            return UserService;
        }
        return {
            request: function (config) {
                config.headers = config.headers || {};
                if(localStorageService.get('token')) {
                    config.headers.Authorization = 'Bearer ' + localStorageService.get('token');
                }
                return config;
            },
            //response: function (response) {
            //    if (response.status === 401) {
            //        // handle the case where the user is not authenticated
            //        alert('form is not authenticated');
            //        throw new Error('form is not authenticated');
            //    }
            //    return response || $q.when(response);
            //},
            'responseError': function(rejection) {
                var alert, textContent = 'Неизвестная ошибка';
                if(rejection.data.logout) {
                    localStorageService.remove("token")
                    return $q.reject('go to auth');
                    //@todo go to auth page

                }
                switch (rejection.status) {
                    case 400:
                        textContent = 'Bad Request';
                        break;
                    case 401:
                        if (rejection.config.method != 'POST') {
                            return $q.reject(rejection);
                        }
                        textContent = 'Авторизуйтесь для начала работы';//'Unauthorized';
                        break;
                    case 403:
                        textContent = 'Доступ запрещен';//'Forbidden';
                        break;
                    case 404:
                        return $q.reject(rejection);
                        textContent = 'Not found';
                        break;
                    case 405:
                        textContent = 'Доступ запрещен';//'method_not_allowed';
                        break;
                    case 409:
                        textContent = 'conflict';
                        break;
                    case 412:
                        textContent = 'precondition_failed';
                        break;
                    case 422:
                        textContent = 'Unprocessable Entity';
                        break;
                    case 429:
                        textContent = 'Слишком много запросов';
                        break;
                    case 500:
                        break;
                }

                if (rejection.data.message) {
                    if (angular.isArray(rejection.data.message)) {
                        textContent = rejection.data.message.join("\n");
                    } else if (angular.isString(rejection.data.message)) {
                        textContent = rejection.data.message;
                    }
                }

                //  getToaster().showSimple(textContent);
                alert = getDialog().alert({
                    title: 'Ошибка',//rejection.config.url,
                    textContent: textContent,
                    ok: 'Закрыть'
                });
                return getDialog()
                    .show(alert)
                    .finally(function () {
                        return $q.reject(rejection);
                    });
                // otherwise, default behaviour
               // return $q.reject(rejection);
            }
        };
    }
})();

